<template>
  <v-container fluid class="pa-0">
    <v-overlay :value="isLoading" absolute>
      <div class="d-flex flex-column align-center justify-center">
        <v-progress-circular indeterminate size="64" :width="5" />
        <span class="my-4">กำลังโหลดข้อมูล</span>
      </div>
    </v-overlay>

    <MarketplaceBanner />
    <MarketplaceRecommend />
    <MarketplaceWeekly />
    <MarketplaceCommunity />
    <MarketplaceService />

  </v-container>
</template>

<script>
import MarketplaceBanner from "@/components/Marketplace/MarketplaceBanner.vue";
import MarketplaceRecommend from "@/components/Marketplace/MarketplaceRecommend.vue";
import MarketplaceWeekly from "@/components/Marketplace/MarketplaceWeekly.vue";
import MarketplaceCommunity from "@/components/Marketplace/MarketplaceCommunity.vue";
import MarketplaceService from "@/components/Marketplace/MarketplaceService.vue";

export default {
  name: "Marketplace",
  components: {
    MarketplaceBanner,
    MarketplaceRecommend,
    MarketplaceWeekly,
    MarketplaceCommunity,
    MarketplaceService,
  },
  data() {
    return { isLoading: false };
  },
};
</script>

<style scoped>
.v-container {
  padding: 0 !important;
}
</style>
